import BlogDetail from "../Pages/Blog/BlogDetail";
import BlogPost from "../Pages/Blog/BlogPost";
import BlogSingle from "../Pages/Blog/BlogSingle";
import BasicCard from "../Pages/Bonus UI/BasicCard";
import BootstrapNotify from "../Pages/Bonus UI/BootstrapNotify";
import BreadcrumbsClass from "../Pages/Bonus UI/Breadcrumb";
import Carousel from "../Pages/Bonus UI/Carousels";
import CreativeCard from "../Pages/Bonus UI/CreativeCard";
import DragAndDrop from "../Pages/Bonus UI/DragAndDrop";
import DropzoneClass from "../Pages/Bonus UI/Dropzone";
import ImageCroppers from "../Pages/Bonus UI/ImageCropper";
import ImageUpload from "../Pages/Bonus UI/ImageUpload";
import Pagination from "../Pages/Bonus UI/Pagination";
import RangeSlider from "../Pages/Bonus UI/RangeSilder";
import RatingClass from "../Pages/Bonus UI/Rating";
import Ribbons from "../Pages/Bonus UI/Ribbon";
import Scrollables from "../Pages/Bonus UI/Scrollable";
import Steps from "../Pages/Bonus UI/Steps";
import Sticky from "../Pages/Bonus UI/Sticky";
import SweetAlerts from "../Pages/Bonus UI/SweetAleart";
import TabCard from "../Pages/Bonus UI/TabCard";
import TimeLines from "../Pages/Bonus UI/TimeLine";
import Tours from "../Pages/Bonus UI/Tours";
import TreeViews from "../Pages/Bonus UI/TreeView";
import Bookmarks from "../Pages/BookMarks";
import DefaultStyle from "../Pages/Buttons/Defaultstyle";
import Draggable from "../Pages/Calender/Draggable Calender";
import Calender from "../Pages/Calender/Index";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJs from "../Pages/Charts/ChartJs";
import GoogleChart from "../Pages/Charts/GoogleChart";
import ChatApp from "../Pages/Chat/ChatApp";
import VideoChat from "../Pages/Chat/VideoChat";
import Contact from "../Pages/Contact";
import Crypto from "../Pages/DashBoard/Crypto";
import Default from "../Pages/DashBoard/Default/Default";
import Ecommerce from "../Pages/DashBoard/Ecommerce/index";
import CheckOut from "../Pages/Ecommerce/CheckOut";
import Invoice from "../Pages/Ecommerce/Invoice/index";
import OrderHistory from "../Pages/Ecommerce/OrderHistory";
import PaymentDetails from "../Pages/Ecommerce/PaymentDetails";
import PricingMembership from "../Pages/Ecommerce/PricingMemberShip";
import ProductCart from "../Pages/Ecommerce/ProductCart";
import ProductList from "../Pages/Ecommerce/ProductList";
import ProductPage from "../Pages/Ecommerce/ProductPage";
import Products from "../Pages/Ecommerce/Products";
import WishList from "../Pages/Ecommerce/Wishlist";
import ACEEditor from "../Pages/Editor/ACECodeEditor";
import CKEditor from "../Pages/Editor/CkEditor";
import MDEEditor from "../Pages/Editor/MDEEditor";
import Compose from "../Pages/Email/Compose";
import MailInbox from "../Pages/Email/Mail Inbox";
import ReadMail from "../Pages/Email/Read Mail";
import FAQ from "../Pages/FAQ";
import FileManager from "../Pages/FileManager";
import BaseInput from "../Pages/Forms/Form Control/BaseInput";
import FormValidation from "../Pages/Forms/Form Control/FormValidation";
import InputGroups from "../Pages/Forms/Form Control/InputGroup";
import MegaOptions from "../Pages/Forms/Form Control/MegaOptions";
import RadioCheckbox from "../Pages/Forms/Form Control/RadioCheckbox";
import FormDefault from "../Pages/Forms/Form Layout/FormDefault";
import FormWizard from "../Pages/Forms/Form Layout/FormWizard";
import FromClipboard from "../Pages/Forms/Form Widgets/FormClipboard";
import FormDatapicker from "../Pages/Forms/Form Widgets/FormDatepicker";
import FormDateRangepicker from "../Pages/Forms/Form Widgets/FormDateRangepicker";
import FormDateTime from "../Pages/Forms/Form Widgets/FormDateTime";
import FormSelect2 from "../Pages/Forms/Form Widgets/FormSelect2";
import FormSwitch from "../Pages/Forms/Form Widgets/FormSwitch";
import FormTouchspin from "../Pages/Forms/Form Widgets/FormTouchSpin";
import FormTypeahead from "../Pages/Forms/Form Widgets/FormTypeahead";
import GalleryGrid from "../Pages/Gallery/GalleryGrid";
import GalleryGridDesc from "../Pages/Gallery/GalleryGridDesc";
import HoverEffects from "../Pages/Gallery/HoverEffect";
import MasonryGallery from "../Pages/Gallery/MasonryGallery";
import MasonryGalleryDesc from "../Pages/Gallery/MasonryGalleryDesc";
import FeatherIcon from "../Pages/Icons/FeatherIcon";
import FlagIcon from "../Pages/Icons/FlagIcons";
import FontAwesome from "../Pages/Icons/FontAwesom";
import IcoIcons from "../Pages/Icons/IcoIcons";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import WhetherIcon from "../Pages/Icons/WhetherIcon";
import ApplyNow from "../Pages/Job Search/Apply";
import CardView from "../Pages/Job Search/CardView";
import JobDetails from "../Pages/Job Search/JobDetail";
import ListView from "../Pages/Job Search/ListView";
import KnowledgeBase from "../Pages/Knowledgebase/KnowledgeBase";
import KnowledgeCategory from "../Pages/Knowledgebase/KnowledgeCategory";
import KnowledgeDetails from "../Pages/Knowledgebase/KnowledgeDetails";
import DetailedList from "../Pages/Learning/DetailedList";
import LearningList from "../Pages/Learning/LearningList";
import LeafletMap from "../Pages/Maps/LeafletMap";
import MapJs from "../Pages/Maps/MapJs";
import CreateList from "../Pages/Project/Create List";
import ProjectList from "../Pages/Project/Project List";
import SamplePage from "../Pages/Sample Page";
import SearchResult from "../Pages/Search Result";
import SocialApp from "../Pages/SocialApp";
import SupportTickit from "../Pages/Support Tickit";
import DataTable from "../Pages/Tables/DataTable";
import BasicTable from "../Pages/Tables/Reactstrap Table/BasicTable";
import BorderTable from "../Pages/Tables/Reactstrap Table/BorderTable";
import SizingTable from "../Pages/Tables/Reactstrap Table/Sizingtable";
import StylingTable from "../Pages/Tables/Reactstrap Table/StylingTable";
import Tasks from "../Pages/Tasks";
import Todo from "../Pages/Todo";
import Accordian from "../Pages/Ui-kit/Accordian";
import Alerts from "../Pages/Ui-kit/Alert";
import Avatars from "../Pages/Ui-kit/Avtars";
import Dropdowns from "../Pages/Ui-kit/Dropdown";
import Grid from "../Pages/Ui-kit/Grid";
import HelperClasses from "../Pages/Ui-kit/HelperClass";
import List from "../Pages/Ui-kit/Lists";
import Modals from "../Pages/Ui-kit/Modals";
import PopOvers from "../Pages/Ui-kit/Popover";
import Progressbars from "../Pages/Ui-kit/Progress";
import Shadow from "../Pages/Ui-kit/Shadows";
import Spinners from "../Pages/Ui-kit/Spinners";
import TabBootstrap from "../Pages/Ui-kit/Tabs/BootstrapTab";
import TabLine from "../Pages/Ui-kit/Tabs/LineTab";
import TagAndPills from "../Pages/Ui-kit/TagAndPills";
import Tooltips from "../Pages/Ui-kit/Tooltip";
import Typography from "../Pages/Ui-kit/Typography";
import UsersCardss from "../Pages/Users/UsersCards";
import UsersEdit from "../Pages/Users/UsersEdit";
import UsersProfile from "../Pages/Users/UsersProfile";
import Charts from "../Pages/Widgets/Charts";
import General from "../Pages/Widgets/General";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard/default/`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce/`, Component: <Ecommerce /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/crypto/`, Component: <Crypto /> },

  { path: `${process.env.PUBLIC_URL}/widgets/general/`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart/`, Component: <Charts /> },

  { path: `${process.env.PUBLIC_URL}/project/projectlist/`, Component: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/project/createlist/`, Component: <CreateList /> },

  { path: `${process.env.PUBLIC_URL}/filemanager`, Component: <FileManager /> },

  { path: `${process.env.PUBLIC_URL}/ecommerce/product`, Component: <Products /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/productpage`, Component: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/productlist`, Component: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/paymentdetails`, Component: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/orderhistory`, Component: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice`, Component: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, Component: <ProductCart /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, Component: <WishList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, Component: <CheckOut /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, Component: <PricingMembership /> },

  { path: `${process.env.PUBLIC_URL}/email/mailbox`, Component: <MailInbox /> },
  { path: `${process.env.PUBLIC_URL}/email/readmail`, Component: <ReadMail /> },
  { path: `${process.env.PUBLIC_URL}/email/compose`, Component: <Compose /> },

  { path: `${process.env.PUBLIC_URL}/chat/chatapp`, Component: <ChatApp /> },
  { path: `${process.env.PUBLIC_URL}/chat/videocall`, Component: <VideoChat /> },

  { path: `${process.env.PUBLIC_URL}/users/userprofile`, Component: <UsersProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/useredit`, Component: <UsersEdit /> },
  { path: `${process.env.PUBLIC_URL}/users/usercard`, Component: <UsersCardss /> },

  { path: `${process.env.PUBLIC_URL}/bookmarks`, Component: <Bookmarks /> },

  { path: `${process.env.PUBLIC_URL}/social-app`, Component: <SocialApp /> },

  { path: `${process.env.PUBLIC_URL}/calandar/basic-calandar`, Component: <Calender /> },
  { path: `${process.env.PUBLIC_URL}/calandar/draggable-calandar`, Component: <Draggable /> },

  { path: `${process.env.PUBLIC_URL}/searchresult`, Component: <SearchResult /> },

  { path: `${process.env.PUBLIC_URL}/forms-control/formValidation`, Component: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms-control/baseInput`, Component: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms-control/inputGroup`, Component: <InputGroups /> },
  { path: `${process.env.PUBLIC_URL}/forms-control/megaOptions`, Component: <MegaOptions /> },
  { path: `${process.env.PUBLIC_URL}/forms-control/radioCheckbox`, Component: <RadioCheckbox /> },

  { path: `${process.env.PUBLIC_URL}/form-widget/datepicker`, Component: <FormDatapicker /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/typeahead`, Component: <FormTypeahead /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/datetimepicker`, Component: <FormDateTime /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/select2`, Component: <FormSelect2 /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/switch`, Component: <FormSwitch /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/touchspin`, Component: <FormTouchspin /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/rangepicker`, Component: <FormDateRangepicker /> },
  { path: `${process.env.PUBLIC_URL}/form-widget/clipboard`, Component: <FromClipboard /> },

  { path: `${process.env.PUBLIC_URL}/form-layout/formDefault`, Component: <FormDefault /> },
  { path: `${process.env.PUBLIC_URL}/form-layout/formWizard`, Component: <FormWizard /> },

  { path: `${process.env.PUBLIC_URL}/todo`, Component: <Todo /> },

  { path: `${process.env.PUBLIC_URL}/tasks`, Component: <Tasks /> },

  { path: `${process.env.PUBLIC_URL}/contacts`, Component: <Contact /> },

  { path: `${process.env.PUBLIC_URL}/blog/blogdetail`, Component: <BlogDetail /> },
  { path: `${process.env.PUBLIC_URL}/blog/blogsingle`, Component: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/blog/blogpost`, Component: <BlogPost /> },

  { path: `${process.env.PUBLIC_URL}/ui-kits/typography/`, Component: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/avatar/`, Component: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/helperclass/`, Component: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/grid/`, Component: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tagsandpills/`, Component: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/progress-bar/`, Component: <Progressbars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal/`, Component: <Modals /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/alert/`, Component: <Alerts /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/popover/`, Component: <PopOvers /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tooltips/`, Component: <Tooltips /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/spinner/`, Component: <Spinners /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/dropdown/`, Component: <Dropdowns /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tab-bootstrap/`, Component: <TabBootstrap /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tab-line/`, Component: <TabLine /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/accordion/`, Component: <Accordian /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/shadow/`, Component: <Shadow /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/list/`, Component: <List /> },

  {
    path: `${process.env.PUBLIC_URL}/learning/learning-list`,
    Component: <LearningList />,
  },
  { path: `${process.env.PUBLIC_URL}/learning/learning-detail`, Component: <DetailedList /> },
  {
    path: `${process.env.PUBLIC_URL}/jobSearch/cardView`,
    Component: <CardView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/jobSearch/job-list`,
    Component: <ListView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/jobSearch/job-detail`,
    Component: <JobDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/jobSearch/job-apply`,
    Component: <ApplyNow />,
  },

  {
    path: `${process.env.PUBLIC_URL}/editor/ckEditor`,
    Component: <CKEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/editor/mdeEditor`,
    Component: <MDEEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/editor/ace-code-editor`,
    Component: <ACEEditor />,
  },

  {
    path: `${process.env.PUBLIC_URL}/knowledgebase`,
    Component: <KnowledgeBase />,
  },
  {
    path: `${process.env.PUBLIC_URL}/knowledgebase/knowledge-category`,
    Component: <KnowledgeCategory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/knowledgebase/knowledge-details`,
    Component: <KnowledgeDetails />,
  },

  {
    path: `${process.env.PUBLIC_URL}/sample-page`,
    Component: <SamplePage />,
  },

  {
    path: `${process.env.PUBLIC_URL}/mapsjs`,
    Component: <MapJs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leafletmap`,
    Component: <LeafletMap />,
  },

  {
    path: `${process.env.PUBLIC_URL}/support-ticket`,
    Component: <SupportTickit />,
  },

  {
    path: `${process.env.PUBLIC_URL}/faq`,
    Component: <FAQ />,
  },

  {
    path: `${process.env.PUBLIC_URL}/gallery/imageGallery`,
    Component: <GalleryGrid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/imageWithDesc`,
    Component: <GalleryGridDesc />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/mesonryGallery`,
    Component: <MasonryGallery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/mesonryDesc`,
    Component: <MasonryGalleryDesc />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/imageHover`,
    Component: <HoverEffects />,
  },

  {
    path: `${process.env.PUBLIC_URL}/tables/basictable`,
    Component: <BasicTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tables/sizingtable`,
    Component: <SizingTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tables/stylingtable`,
    Component: <StylingTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tables/bordertable`,
    Component: <BorderTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tables/datatable`,
    Component: <DataTable />,
  },

  {
    path: `${process.env.PUBLIC_URL}/button`,
    Component: <DefaultStyle />,
  },

  {
    path: `${process.env.PUBLIC_URL}/icons/flagicon`,
    Component: <FlagIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/fontawesome`,
    Component: <FontAwesome />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/ico`,
    Component: <IcoIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/thimify`,
    Component: <ThemifyIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/feather`,
    Component: <FeatherIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/wheater`,
    Component: <WhetherIcon />,
  },

  {
    path: `${process.env.PUBLIC_URL}/charts/apex`,
    Component: <ApexChart />,
  },

  {
    path: `${process.env.PUBLIC_URL}/charts/chartjs`,
    Component: <ChartJs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/charts/google`,
    Component: <GoogleChart />,
  },

  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/card/basicCards`,
    Component: <BasicCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/card/creativeCards`,
    Component: <CreativeCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/card/tabCard`,
    Component: <TabCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/carousel`,
    Component: <Carousel />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`,
    Component: <BreadcrumbsClass />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/imageCropper`,
    Component: <ImageCroppers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`,
    Component: <Scrollables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/bootstrap-notify`,
    Component: <BootstrapNotify />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/rating`,
    Component: <RatingClass />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`,
    Component: <DropzoneClass />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/tourComponent`,
    Component: <Tours />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`,
    Component: <Ribbons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/rangeSlider`,
    Component: <RangeSlider />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/pagination`,
    Component: <Pagination />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/image-upload`,
    Component: <ImageUpload />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/stickyNotes`,
    Component: <Sticky />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/timelines/timeline1`,
    Component: <TimeLines />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/sweetAlert`,
    Component: <SweetAlerts />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/treeview`,
    Component: <TreeViews />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/dragNDropComp`,
    Component: <DragAndDrop />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus-ui/step`,
    Component: <Steps />,
  },
];
